'use strict';

import Masonry from 'masonry-layout';
import gaHelper from 'ga-helper';
import $ from 'jquery';
import fontFinally from '../../../general/js/font-loader';
import pageSpinner from 'page-spinner';
import scroller from 'scroller';

export default class Listing {
    constructor(el) {
        this.container = el;
        this.$container = $(this.container);
        this.isLoading = false;
        this.filterSelector = '.js-listing-filter';
        this.filterFieldSelector = '.js-listing-filter-field';
        this.gridSelector = '.js-listing-grid';
        this.gridItemSelector = '.js-listing-item';
        this.stampItemSelector = '.js-listing-stamp';
        this.emptyMessageSelector = '.js-empty-message';
        this.transitionDuration = 500;
        this.filterFields = [];
        this.filterReset = null;

        this.currentPage = 1;
    }

    init() {
        this.initConfig();

        this.grid = this.container.querySelector(this.gridSelector);
        this.filter = this.container.querySelector(this.filterSelector);
        this.emptyMessage = this.container.querySelector(this.emptyMessageSelector);

        if (this.filter) {
            this.filterFields = [...this.filter.querySelectorAll(this.filterFieldSelector)];
            this.filterReset = this.filter.querySelector('.js-listing-filter-reset');
        }

        this.bootstrap();
    }

    initConfig() {
        this.endpointUrl = this.container.getAttribute('data-endpoint-url');
        let multiColumnAttribute = this.container.getAttribute('data-multicolumn');
        this.isMultiColumn = multiColumnAttribute === null || multiColumnAttribute === "true";
    }

    bootstrapFinish() {
        this.initPagination();
        if (this.filter) {
            this.filter.addEventListener("change", this.onFilterChange.bind(this));
            if (this.isNeedTrackFilter()) {
                this.filter.addEventListener("change", this.trackFilter.bind(this));
            }
        }
        if (this.filterReset) {
            this.filterReset.addEventListener("click", this.resetFilter.bind(this));
        }
        pageSpinner.hide();
    }

    bootstrap() {
        pageSpinner.show();
        if (this.isMultiColumn) {
            this.bootstrapPromise = fontFinally.then(() => {
                setTimeout(() => {
                    this.masonry = new Masonry(this.grid, {
                        columnWidth: this.gridItemSelector,
                        itemSelector: this.gridItemSelector,
                        stamp: this.stampItemSelector,
                        percentPosition: true,
                        transitionDuration: this.transitionDuration,
                        stagger: 30,
                        horizontalOrder: true
                    });

                    this.bootstrapFinish();
                }, 200);
            });
        } else {
            this.bootstrapPromise = Promise.resolve().then(() => {
                this.bootstrapFinish();
            })
        }
    }

    render(page = 1, append = false) {
        this.isLoading = true;

        return this.getData(page).then((response) => {
            this.currentPage = page;
            return this.renderData(response, append);
        }, (error) => {
            console.log(error);
        }).then(() => {
            this.isLoading = false;
        })
    }

    getData(page) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: this.getUrl(page),
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    removeItems(currentItems) {
        if (this.isMultiColumn) {
            this.masonry.remove(currentItems);
        } else {
            currentItems.forEach((item) => {
                this.grid.removeChild(item);
            });
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, this.transitionDuration)
        });
    }

    appendItems(items, append) {
        items.forEach((item) => {
            this.grid.appendChild(item);
        });

        if (this.isMultiColumn) {
            this.masonry.appended(items);
            if (!append) {
                this.masonry.layout();
            }
        }
    }

    renderData(itemsHtml, append) {
        return this.bootstrapPromise.then(() => {
            let domParser = new DOMParser();
            let pseudoDocument = domParser.parseFromString(itemsHtml, "text/html");
            let items = [...pseudoDocument.querySelectorAll(this.gridItemSelector)];

            if (!append) {
                let currentItems = this.grid.querySelectorAll(`${this.gridItemSelector}:not(.js-listing-item-pinned)`);
                currentItems = [...currentItems];
                let listingClearPromise = this.removeItems(currentItems);
                this.handleEmptyResponse(items, listingClearPromise);
            }

            this.appendItems(items, append);
            this.updatePagination(pseudoDocument);
        })
    }

    onFilterChange() {
        this.updateResetState();
        this.currentPage = null;
        pageSpinner.show();
        this.render().then(() => {
            pageSpinner.hide();
        })
    }

    resetFilter(e) {
        e.preventDefault();
        this.filterFields.forEach(x => x.value = "");
        this.$container.trigger('flatpickr:clear');
        this.onFilterChange();
        var dropdownTextarea = document.querySelectorAll('.textAreaBtn');
        for(let t=0; t<dropdownTextarea.length; t++){
            dropdownTextarea[t].style.cssText = "text-indent: -100%";
        }

        for(let i=0; i < this.filterFields.length; i++) {
            if (this.filterFields[i].options) {
                Array.from(this.filterFields[i].options).forEach(o => o.selected = false);
            }
        }

        var items = document.getElementsByTagName('input');
        for(let i=0; i<items.length; i++){
            if(items[i].type=='checkbox')
                items[i].checked=false;
        }
    }

    updateResetState() {
        let isFilled = this.filterFields.some(x => x.value);
        if (isFilled) {
            this.filterReset.classList.add("btn--violet");
            this.filterReset.classList.remove("btn--disabled");
            this.filterReset.disabled = false;
        } else {
            this.filterReset.classList.remove("btn--violet");
            this.filterReset.classList.add("btn--disabled");
            this.filterReset.disabled = 'disabled';
        }
    }

    getUrl(page) {
        let params = this.getRequestParams();
        if (page !== null) {
            params['page'] = page;
        }
        let paramsString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
        let paramsPrefix = this.endpointUrl.indexOf('?') === -1 ? '?' : '&';
        return `${this.endpointUrl}` + (paramsString !== '' ? `${paramsPrefix}${paramsString}` : '');
    }

    getRequestParams() {
        let arrayRegexp = /(.+)\[(.*)\]/;

        let result = this.filterFields.reduce((result, field) => {
            if (field && field.selectedOptions && field.selectedOptions.length > 0) {
                result[field.name] = Array.from(field.selectedOptions).map((x) => x.value);
            }
            
            if (field && field.value && Array.from(field.classList).includes('js-rangepicker')) {
                result[field.name] = field.value;
            }

            return result;
            }, {});


        Object.keys(result).map(function (key) {
            let value = result[key];
            if (Array.isArray(value)) {
                value = value.join(',');
            }
            result[key] = value;
        });

        return result;
    }

    updatePagination(container) {
        throw new Error('method not implemented');
    }

    initPagination() {
        throw new Error('method not implemented');
    }

    isNeedTrackFilter() {
        return this.endpointUrl.indexOf('events') !== -1;
    }

    trackFilter(e) {
        if (!this.isFilterEmpty()) {
            gaHelper.ga('send', 'event', this.getTrackingEventCategory(), this.getTrackingEventAction(), this.getTrackingEventLabel());
        }
    }

    getTrackingEventCategory() {
        if (this.endpointUrl.indexOf('events') !== -1) {
            return 'Find The Right Event';
        } else {
            return 'unknown';
        }
    }

    getTrackingEventAction() {
        if (this.endpointUrl.indexOf('events') !== -1) {
            return 'Search';
        } else {
            return 'unknown';
        }
    }

    getTrackingEventLabel() {
        if (this.endpointUrl.indexOf('events') !== -1) {
            let params = this.getRequestParams();
            return `${params['startdate'] || 'n/a'} > ${params['type'] || 'n/a'} > ${params['location'] || 'n/a'}`
        } else {
            return 'unknown';
        }
    }

    isFilterEmpty() {
        if (this.endpointUrl.indexOf('events') !== -1) {
            let params = this.getRequestParams();
            return !params['startdate'] && !params['type'] && !params['location'];
        } else {
            return true;
        }
    }

    handleEmptyResponse(items, listingClearPromise) {
        //current items removed and new array has 0 items
        if (items.length === 0) {
            this.container.classList.add('is-empty');
            listingClearPromise.then(() => {
                scroller.scrollToElement(this.emptyMessage);
            });
        } else {
            this.container.classList.remove('is-empty');
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/listing/js/listing.js